import {
	ElementRef,
	Injectable,
	Renderer2,
	RendererStyleFlags2,
} from '@angular/core';

@Injectable()
export class GroupingTagListViewProvider {
	private readonly GAP_PX = 48;
	private readonly PANEL_HEADER = 80;

	public adjustHeights(elemRef: ElementRef, renderer: Renderer2): void {
		const container = document.querySelector('#app') as HTMLElement | null;

		const footer = document.querySelector('.footer') as HTMLElement | null;

		const header = document.querySelector(
			'.header-group'
		) as HTMLElement | null;

		const pageHeader = elemRef.nativeElement.querySelector('.app-page__header');

		const subscriptionList = document.querySelector(
			'.grouping-tag-list'
		) as HTMLElement | null;

		if (!subscriptionList || !pageHeader || !header || !container || !footer) {
			return;
		}

		const subscriptionListHeight =
			container.offsetHeight -
			header.offsetHeight -
			footer.offsetHeight -
			pageHeader.offsetHeight -
			this.PANEL_HEADER -
			this.GAP_PX;

		renderer.setStyle(
			subscriptionList,
			'--max-height-grouping-tag-list',
			`${subscriptionListHeight}px`,
			RendererStyleFlags2.DashCase
		);
	}
}
